import { Component, Input, Output, EventEmitter, OnInit, ElementRef, Renderer2 as Renderer } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UpgradeLogFilter } from '../../upgrade-logs-viewer.model';
import { UpgradeLogsFilterService } from '../../services/upgrade-logs-filter.service';
import { CreateCustomBlockSizeType, ICustomBlock } from '../../../decorators';

@CreateCustomBlockSizeType({
  'breakpoint-768': 768,
  'breakpoint-1024': 1024,
})
@Component({
  selector: 'lib-device-search',
  templateUrl: './device-search.component.html',
  styleUrls: ['./device-search.component.scss']
})
export class DeviceSearchComponent implements OnInit, ICustomBlock {
  @Input() filters: UpgradeLogFilter | null = {};
  @Input() labels: any = {};

  @Output() filterChanged = new EventEmitter<UpgradeLogFilter>();

  searchForm: FormGroup;

  // ICustomBlock properties
  width?: number;
  currentWidth?: number;

  constructor(
    private fb: FormBuilder,
    private filterService: UpgradeLogsFilterService,
    public el: ElementRef,
    public renderer: Renderer
  ) {
    this.searchForm = this.fb.group({
      deviceSerial: ['', [Validators.minLength(3)]],
      dateFrom: [''],
      dateTo: [''],
      operatorId: ['']
    });
  }

  ngOnInit(): void {
    // Initialize form with current filters
    if (this.filters) {
      this.searchForm.patchValue({
        deviceSerial: this.filters.deviceSerial || '',
        dateFrom: this.filters.dateRange?.from || '',
        dateTo: this.filters.dateRange?.to || '',
        operatorId: this.filters.operatorId || ''
      });
    }

    // Subscribe to form changes
    this.searchForm.valueChanges.subscribe(formValue => {
      this.emitFilterChange(formValue);
    });
  }

  onSearch(): void {
    if (this.searchForm.valid) {
      this.emitFilterChange(this.searchForm.value);
    }
  }

  onClear(): void {
    this.searchForm.reset();
    this.emitFilterChange({});
  }

  private emitFilterChange(formValue: any): void {
    const filter: UpgradeLogFilter = {
      deviceSerial: formValue.deviceSerial?.trim() || undefined,
      dateRange: (formValue.dateFrom && formValue.dateTo) ? {
        from: new Date(formValue.dateFrom),
        to: new Date(formValue.dateTo)
      } : undefined,
      operatorId: formValue.operatorId?.trim() || undefined
    };

    this.filterChanged.emit(filter);
  }

  // Validation helpers
  get deviceSerialError(): string | null {
    const control = this.searchForm.get('deviceSerial');
    if (control?.errors && control.touched) {
      if (control.errors['minlength']) {
        return 'Device serial must be at least 3 characters';
      }
    }
    return null;
  }

  get dateRangeError(): string | null {
    const fromControl = this.searchForm.get('dateFrom');
    const toControl = this.searchForm.get('dateTo');

    if (fromControl?.value && toControl?.value) {
      const from = new Date(fromControl.value);
      const to = new Date(toControl.value);

      if (!this.filterService.validateDateRange(from, to)) {
        return 'Invalid date range';
      }
    }

    return null;
  }
}